<form [formGroup]="form" *ngIf="formInitialized$ | async">
  <ng-container *ngIf="!editing">
    <h2>Create tracking categories in QuickBooks</h2>
  </ng-container>
  <sbnb-accounting-form-tracking-categories formGroupName="properties"></sbnb-accounting-form-tracking-categories>

  <div class="mt-4 flex justify-end">
    <sbnb-button [disabled]="saving$ | async" (click)="save()">Save</sbnb-button>
  </div>
</form>
